import React from 'react'

export default function LocalIcon(props) {
  return (
        <svg x="0px" y="0px" viewBox="0 0 512 512" {...props}>
            <g>
                <g>
                    <g>
                        <path d="M478.068,325.565H167.691V178.087c0-19.946-16.228-36.174-36.174-36.174s-36.174,16.228-36.174,36.174v147.478H33.932
				C15.222,325.565,0,340.787,0,359.497v76.831c0,18.71,15.222,33.932,33.932,33.932h444.135c18.71,0,33.932-15.222,33.932-33.932
				v-76.831C512,340.787,496.778,325.565,478.068,325.565z M117.604,178.087c0-7.672,6.241-13.913,13.913-13.913
				c7.672,0,13.913,6.241,13.913,13.913v147.478h-27.826V178.087z M489.739,436.329c0,6.436-5.236,11.671-11.671,11.671H33.932
				c-6.436,0-11.671-5.236-11.671-11.671v-76.831c0-6.436,5.236-11.671,11.671-11.671h444.135c6.436,0,11.671,5.236,11.671,11.671
				V436.329z"/>
                        <path d="M131.517,91.826c-35.96,0-68.493,22.696-80.956,56.475c-2.128,5.768,0.823,12.168,6.589,14.295
				c5.764,2.126,12.168-0.823,14.295-6.589c9.25-25.074,33.391-41.919,60.071-41.919s50.82,16.846,60.072,41.919
				c1.66,4.497,5.915,7.282,10.444,7.282c1.279,0,2.581-0.223,3.851-0.691c5.768-2.128,8.717-8.528,6.589-14.295
				C200.011,114.522,167.476,91.826,131.517,91.826z"/>
                        <path d="M12.685,137.045c1.483,0.667,3.033,0.982,4.559,0.982c4.246,0,8.302-2.443,10.158-6.567
				C45.834,90.479,86.702,64,131.517,64c44.816,0,85.683,26.479,104.115,67.459c2.522,5.606,9.11,8.105,14.717,5.585
				c5.606-2.522,8.106-9.111,5.585-14.717c-22.019-48.956-70.856-80.589-124.417-80.589c-53.561,0-102.397,31.633-124.417,80.589
				C4.579,127.934,7.08,134.522,12.685,137.045z"/>
                        <path d="M442.15,370.087c-6.147,0-11.13,4.983-11.13,11.13v33.391c0,6.147,4.983,11.13,11.13,11.13s11.13-4.983,11.13-11.13
				v-33.391C453.28,375.07,448.297,370.087,442.15,370.087z"/>
                        <path d="M397.628,370.087c-6.147,0-11.13,4.983-11.13,11.13v33.391c0,6.147,4.983,11.13,11.13,11.13
				c6.147,0,11.13-4.983,11.13-11.13v-33.391C408.759,375.07,403.775,370.087,397.628,370.087z"/>
                        <path d="M353.106,370.087c-6.147,0-11.13,4.983-11.13,11.13v33.391c0,6.147,4.983,11.13,11.13,11.13
				c6.147,0,11.13-4.983,11.13-11.13v-33.391C364.237,375.07,359.254,370.087,353.106,370.087z"/>
                        <path d="M308.585,370.087c-6.147,0-11.13,4.983-11.13,11.13v33.391c0,6.147,4.983,11.13,11.13,11.13
				c6.147,0,11.13-4.983,11.13-11.13v-33.391C319.715,375.07,314.732,370.087,308.585,370.087z"/>
                        <path d="M264.063,370.087c-6.147,0-11.13,4.983-11.13,11.13v33.391c0,6.147,4.983,11.13,11.13,11.13
				c6.147,0,11.13-4.983,11.13-11.13v-33.391C275.193,375.07,270.21,370.087,264.063,370.087z"/>
                        <path d="M69.465,378.366h-5.287c-6.147,0-11.13,4.983-11.13,11.13c0,6.147,4.983,11.13,11.13,11.13h5.287
				c6.147,0,11.13-4.983,11.13-11.13C80.596,383.349,75.612,378.366,69.465,378.366z"/>
                        <path d="M182.161,378.366h-67.339c-6.147,0-11.13,4.983-11.13,11.13c0,6.147,4.983,11.13,11.13,11.13h67.339
				c6.147,0,11.13-4.983,11.13-11.13C193.291,383.349,188.308,378.366,182.161,378.366z"/>
                    </g>
                </g>
            </g>
        </svg>
  )
}
